// React
import React, { useState } from 'react';
// Styles
import './styles.scss';
// Icons
import { Alert } from 'react-bootstrap';

/**
 * Alert dismissible for notifications
 * @param {*} props.show updates the variable to show/hide the alert
 * @param {*} props.text the text to show in the alert
 * @param {*} props.text the style of the alert  e.g. 'success' or 'danger'
 * @returns {React.Component}
 */
const DEFAULT_TIMEOUT = 4000;
const HIDE_ANIMATION_DURATION = 500;

function AlertDismissible(props) {
    const [className, setClassName] = useState(props.show ? 'alert-show-animation' : '');

    React.useEffect(() => {
        if (props.show) {
            // Starts the animation
            setClassName('alert-show-animation');

            // Start the hide animation 500 ms before the alert closes on timeout
            setTimeout(() => {
                if (props.show) {
                    setClassName('alert-hide-animation');
                }
            }, props.timeout ? props.timeout - HIDE_ANIMATION_DURATION : DEFAULT_TIMEOUT - HIDE_ANIMATION_DURATION);

            // Closes the alert on timeout
            setTimeout(() => {
                setClassName('');
                props.onClose(false);
            }, props.timeout ? props.timeout : DEFAULT_TIMEOUT);
        }
    }, [props.show]);

    if (props.show) {
        return (
            <Alert
                className={className}
                variant={props.type}
                onClose={() => props.onClose(false)}
                dismissible
            >
                {props.text}
            </Alert>
        );
    }
    return null;
}

export default AlertDismissible;
